import { useCallback, useEffect } from "react";

const desktopScrollTo = 216;
const mobileScrollTo = 139;


export function useInitialWindowScrollTo() {
  useEffect(()=>{
    window.innerWidth < 992 ? window.scrollTo(0, mobileScrollTo) : window.scrollTo(0, desktopScrollTo);
  },[])
}

export function useWindowScrollTo() {
  const toScroll = useCallback(() => {
    window.innerWidth < 992 ? window.scrollTo(0, mobileScrollTo) : window.scrollTo(0, desktopScrollTo);
  }, []);

  return {toScroll};
}